import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Toaster } from '@/components/ui/toaster';

import GoogleCallbackHandler from './components/auth/GoogleCallbackHandler';
import LoginPage from './components/auth/LoginPage';
import AppRoutes from './routes/AppRoutes.tsx';
import PayPalCallback from './components/Subscriptions/PayPalCallback';
import { useAuth } from './components/auth/AuthContext';
import ChangelogModal from './components/changelog/ChangelogModal.tsx';
import './App.css';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const GOOGLE_OAUTH_CALLBACK_PATH = process.env.REACT_APP_GOOGLE_OAUTH_CALLBACK_PATH || "/google-oauth/login-callback";

function App() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const [selectedTab, setSelectedTab] = useState<number>(0);

  // Show loading spinner while auth state is being determined
  // This prevents premature redirects to /upload before auth completes
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <>
      <Toaster />
      {isAuthenticated && <ChangelogModal />}
      <Router>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Routes>
            <Route
              path={GOOGLE_OAUTH_CALLBACK_PATH}
              element={<GoogleCallbackHandler />}
            />
            {/* PayPal callback - public route, no auth required (used in popup windows) */}
            <Route
              path="/subscriptions/paypal-callback"
              element={<PayPalCallback />}
            />
            <Route
              path="/*"
              element={
                <AppRoutes
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                  isAuthenticated={isAuthenticated}
                  onLogin={login}
                  GOOGLE_CLIENT_ID={GOOGLE_CLIENT_ID}
                />
              }
            />
          </Routes>
        </LocalizationProvider>
      </Router>
    </>
  );
}

export default App;
